import { BaseEntity, DefaultResponseWithData } from "./system";
import { IVehicle } from "./Vehicle";

export interface IQuoteResponse extends DefaultResponseWithData<IQuote> { }

export interface IQuotesResponse extends DefaultResponseWithData<IQuote[]> { }

export interface IQuote extends BaseEntity {
    vehicleRegistration: string;
    vehicleMake: string;
    vehicleModel: string;
    mileage: number;
    year: number;
    alloyWheels: boolean;
    engineCondition: EngineCondition;
    bodyCondition: BodyCondition;
    status: Status,

    priceCollected: number;
    collectedType: QuoteType;
    collectedCustomerId: string;
    collectedCalculationJson: string;

    priceDropOff: number;
    dropOffType: QuoteType;
    dropOffCustomerId: string;
    dropOffCalculationJson: string;

    amendedPrice?: number | null;

    sourceCustomerId: string;
    assignedCustomerId?: string;

    sourceWebsiteId?: string | null;
    sourceWebsiteDomain?: string | null;
    sourceWebsitePrimaryColor?: string | null;

    convertedToLeadOn?: string;

    sortCode: string;
    accountNumber: string;
    bankAccountName: string;
    roadSidePayment: boolean;
    fastPayment: boolean;

    selectedDropOff: boolean;
    
    accessToVehicle: boolean;
    // The API camel-cases V5C as v5C. Reading V5C / Keys always came back undefined.
    v5C: boolean;
    keys: number;

    contactId: string;
    postcode: string;

    // Google Ads click identifier, present only when the quote came from a paid click
    gclid?: string | null;

    step: number;
    furthestStep: number;

    contact: IContact;
    vehicle: IVehicle;

    voucherCode: string;
}

export interface IContact extends BaseEntity {
    firstName: string;
    lastName: string;
    fullname: string;
    email: string;
    telephone1: string;
    postcode: string;
    addressLine1: string;
    addressLine2: string;
    addressLine3: string;
    locality: string;
    town: string;
    city: string;
    county: string;
    notes: string;
}

export interface ICalculationData {
    salvageCalculations: ICalculation[];
    tradePoorCalculations: ICalculation[];
    salvageVoucherCalculation: ICalculation;
    // scrap
    postcodeCalculations: ICalculation[];
    catalyticCalculations: ICalculation[];
    engineCalculations: ICalculation[];
    vfeCalculations: ICalculation[];
    generalCalculations: ICalculation[];
    genericCalculations: ICalculation[];
    additionalCalculations: ICalculation[];
    scrapVoucherCalculation: ICalculation;
    // lookup
    partsLookupCalculations: ICalculation[];
    partsLookupGenericCalculations: ICalculation[];
    // other
    dropOff: number;
    payment: ICalculation;
}

export interface ICalculation {
    name: string;
    isFixed: boolean;
    value: number;
    baseValue: number;
    isAddition: boolean;
    dropOff?: boolean | null;
    customCalculation: string;
}

export enum EngineCondition {
    NoFault,
    MinorFault,
    MajorFault,
}

export enum BodyCondition {
    Good,
    Average,
    HeavyDamage,
}

export enum Status {
    NoMatch,
    Match,
    Generated,
    AcceptedCollection,
    AcceptedDropOff
}

export enum QuoteType {
    ScrapExport,
    Salvage,
    SmartPrice
}

export enum QuoteSelection {
    Collection,
    DropOff
}